import React from "react";
import ListPageLayout from "@layouts/ListPageLayout";
import BtnAddNew from "@components/BtnAddNew/BtnAddNew";
import {withRouter} from "react-router";

import MemberPurchaseForm from './MemberPurchaseForm';
import MemberPurchaseTable from './MemberPurchaseTable';

import UserBetRecordListTable from '@ViewsDashboard/User/UserList/UserBetRecord/UserBetRecordListTable';
import update_to_agent_store from '@store/Agent/UpdateToAgentStore';
import member_purchase_store ,{pagination_store,filter_store} from '@store/Purchase/MemberPurchaseStore';
import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

@withRouter
class MemberPurchaseList extends React.PureComponent
{
    constructor(props) {
        super();

        let state = props.location.state;
        let id = props.location.id;
        this.updateDatas(state,id);
    }

    componentWillReceiveProps(props, nextContext) {
        let state   = props.location.state;
        let username = props.match.params.username;
        let id      = props.match.params.id;

        this.updateDatas(state,id,username)
    }

    updateDatas(state,id,username) {
        breadcrumb_store.resetByName('购彩列表');
        if (state == undefined) {
            filter_store.resetAttr()
        } else {
            filter_store.setAttr(state)
        }

    }
    showAddNewAgentModal = () => {
        update_to_agent_store.openModal();
    }

    render() {
        return (
            <ListPageLayout
                isCustomHeader
                header={
                    <MemberPurchaseForm />
                }
                list={
                    <MemberPurchaseTable />
                }
                modal={
                    <div>
                        {}
                    </div>
                }
            />
        );
    }
}

export default MemberPurchaseList;


// WEBPACK FOOTER //
// ./src/ViewsDashboard/Agent/memberPurchase/MemberPurchaseList.jsx